import { onMount, onDestroy } from '@/modules/_'

export default function (element, dataset) {
  // console.log("bottom-hero-nav initialized [v5 - minimal]", element);
  const hasCookie = document.cookie.includes('goose=true')
  const hasDirectAccess = new URLSearchParams(window.location.search).has(
    'directaccess'
  )
  console.log('menu Has Cookie', hasCookie)
  console.log('menu Has Direct Access', hasDirectAccess)

  // If user has direct access but no cookie, set the cookie
  if (hasDirectAccess && !hasCookie) {
    document.cookie = 'goose=true; path=/; max-age=31536000' // 1 year
    console.log('Cookie set due to direct access')
  }

  if (hasCookie || hasDirectAccess) {
    element.dataset.sotwNav = 'unlocked'

    // Select all data-chapters elements and set them to unlocked
    const chapterElements = document.querySelectorAll('[data-chapters]')
    chapterElements.forEach((el) => {
      el.setAttribute('data-chapters', 'unlocked')
    })
  }

  // Get references
  const button = element.querySelector('.ww-micro-nav_btn')
  const closeButton = element.querySelector('.ww-micro-nav_close')
  const overlay = document.querySelector('.ww-micro-overlay')

  // State
  let isOpen = false

  // Open menu
  const openMenu = () => {
    if (isOpen) return
    isOpen = true

    // Add state to button - CSS handles the rest
    if (button) {
      button.setAttribute('data-micro-nav', 'open')
      button.setAttribute('aria-expanded', 'true')
    }

    // Show overlay
    if (overlay) {
      overlay.setAttribute('data-micro-nav', 'visible')
    }

    // console.log("Menu opened");
  }

  // Close menu
  const closeMenu = () => {
    if (!isOpen) return
    isOpen = false

    // Remove state from button
    if (button) {
      button.removeAttribute('data-micro-nav')
      button.setAttribute('aria-expanded', 'false')
    }

    // Hide overlay
    if (overlay) {
      overlay.removeAttribute('data-micro-nav')
    }

    // console.log("Menu closed");
  }

  // Toggle menu
  const toggleMenu = () => {
    if (isOpen) {
      closeMenu()
    } else {
      openMenu()
    }
  }

  // Event handlers
  const handleButtonClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    toggleMenu()
  }

  const handleCloseClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    closeMenu()
  }

  const handleOverlayClick = () => {
    closeMenu()
  }

  // Click outside to close
  const handleDocumentClick = (e) => {
    if (!isOpen) return
    if (!element.contains(e.target)) {
      closeMenu()
    }
  }

  // ESC key to close
  const handleKeyDown = (e) => {
    if (e.key === 'Escape' && isOpen) {
      closeMenu()
    }
  }

  // Lifecycle: Mount
  onMount(() => {
    // console.log("bottom-hero-nav mounted");

    if (button) button.addEventListener('click', handleButtonClick)
    if (closeButton) closeButton.addEventListener('click', handleCloseClick)
    if (overlay) overlay.addEventListener('click', handleOverlayClick)

    document.addEventListener('click', handleDocumentClick)
    document.addEventListener('keydown', handleKeyDown)
  })

  // Lifecycle: Cleanup
  onDestroy(() => {
    // console.log("bottom-hero-nav destroyed");

    if (button) button.removeEventListener('click', handleButtonClick)
    if (closeButton) closeButton.removeEventListener('click', handleCloseClick)
    if (overlay) overlay.removeEventListener('click', handleOverlayClick)

    document.removeEventListener('click', handleDocumentClick)
    document.removeEventListener('keydown', handleKeyDown)
  })
}
